import { useTitle as vueUseTitle } from '@vueuse/core';
import { useRoute } from 'vue-router';

const DEFAULT_TITLE = 'Tradier Web';
const DEFAULT_SEPARATOR = ' | ';

export function useTitle(newTitle, to) {
  const route = to || useRoute();

  const routeTitles = route.matched.map((route) => route.meta?.title).filter((title) => title);
  if (newTitle !== '') routeTitles.push(newTitle);

  const title = vueUseTitle('', { titleTemplate: `%s${DEFAULT_SEPARATOR}${DEFAULT_TITLE}` });
  title.value = routeTitles.reverse().join(DEFAULT_SEPARATOR);
}
